import React from 'react';
import { Button, tokens } from '@fluentui/react-components';
import i18n from '../i18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Neperimta klaida puslapyje:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '60vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', textAlign: 'center',
        padding: tokens.spacingVerticalXXL, gap: tokens.spacingVerticalM,
        fontFamily: tokens.fontFamilyBase,
      }}>
        <h2 style={{ margin: 0, color: tokens.colorNeutralForeground1 }}>{i18n.t('error_boundary.title')}</h2>
        <p style={{ color: tokens.colorNeutralForeground3, margin: 0 }}>
          {i18n.t('error_boundary.text')}
        </p>
        <Button appearance="primary" onClick={() => window.location.reload()}>
          {i18n.t('error_boundary.reload')}
        </Button>
      </div>
    );
  }
}

export default ErrorBoundary;
